/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Company_CompanyDto } from '../models/Wealthlane_CustomerService_Dtos_Company_CompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServicedCompanyService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Company_CompanyDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppServicedCompanyMyCompanies(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Company_CompanyDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/serviced-company/my-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
